<style scoped>
.need_help {
  font-size: 22px;
  line-height: 26px;
}
</style>

<template>
  <div>
    <base-toolbar>
      <v-spacer></v-spacer>
      <div v-if="$route.name !== 'sharedCard'">
        <v-btn
          v-if="!isDownloadPage && is_card"
          depressed
          color="transparent"
          rounded
          :to="{
            name: 'editCard',
            params: { card_id: card_table_id }
          }"
        >
          <v-icon left>{{ mdiPencil }}</v-icon> Edit
        </v-btn>
        <v-btn
          v-if="!isDownloadPage"
          class="ml-2"
          color="transparent"
          depressed
          rounded
          :loading="shareDialogLoading"
          @click="shareCardTemplate"
        >
          <v-icon left>{{ mdiShareVariant }}</v-icon> Share
        </v-btn>
      </div>
    </base-toolbar>

    <v-container fluid>
      <!-- %%%%%%%%%%%%%%%% PAGE TITLE SECTION  %%%%%%%%%%%%%%%%-->
      <!--  for large screen laptop/monitor -->
      <v-row justify="center" class="border-b large-screen">
        <v-col cols="12" md="8" class="pt-0">
          <v-row class="px-5">
            <v-col cols="6" md="4" class="py-2 ">
              <span class="page-title">
                {{ template_details.template_name }}
              </span>
            </v-col>
            <!-- for preview and view -->
            <v-col
              v-if="!isDownloadPage"
              cols="12"
              md="8"
              class="text-right px-0 py-2"
            >
              <div class="d-flex justify-end elevation-0">
                <div class="align-self-center pr-5">
                  <v-btn
                    rounded
                    block
                    outlined
                    :loading="shareDialogLoading"
                    @click="shareCardTemplate"
                  >
                    <v-icon class="px-1">{{ mdiShareVariant }}</v-icon>
                    {{ $t("SHARE") }}
                  </v-btn>
                </div>
                <div v-if="is_card" class="align-self-center pr-5">
                  <v-btn
                    rounded
                    block
                    outlined
                    @click="
                      $router.push({
                        name: 'editCard',
                        params: { card_id: card_table_id }
                      })
                    "
                  >
                    <v-icon class="px-1">{{ mdiPencil }}</v-icon>
                    {{ $t("EDIT") }}
                  </v-btn>
                </div>
                <div v-if="is_card">
                  <v-btn
                    class="px-5"
                    rounded
                    block
                    color="primary"
                    dark
                    style="max-width:228px;"
                    @click="downloadDialog = true"
                  >
                    <span class="px-5">
                      {{ $t("DOWNLOAD_CARD") }}
                    </span>
                  </v-btn>
                </div>
                <div v-if="!is_card">
                  <v-btn
                    v-if="template_id"
                    class="px-5"
                    rounded
                    block
                    color="primary"
                    dark
                    @click="
                      $router.push({
                        name: 'createCard',
                        params: { template_id }
                      })
                    "
                  >
                    <span class="px-2">
                      {{ $t("TRY_THIS_CARD_FOR_FREE") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-col>

            <!-- For download Page -->
            <v-col v-else cols="12" md="8" class="text-right px-0 py-2">
              <div class="d-flex justify-end elevation-0">
                <div class="align-self-center pr-5">
                  <v-btn
                    rounded
                    block
                    outlined
                    :loading="shareDialogLoading"
                    @click="shareCardTemplate"
                  >
                    <v-icon class="px-1">{{ mdiShareVariant }}</v-icon>
                    {{ $t("SHARE") }}
                  </v-btn>
                </div>
                <div v-if="is_card">
                  <v-btn
                    class="px-5"
                    rounded
                    block
                    color="primary"
                    dark
                    style="max-width:228px;"
                    :loading="downloading"
                    @click="handleDownloadCardOnDownloadPage"
                  >
                    <span class="px-5">
                      {{ $t("DOWNLOAD_CARD") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <CardPDFPreview :pdf-url="pdfUrl"></CardPDFPreview>

      <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
      <!--  page  bottom action button set for large screen  -->
      <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
      <v-row justify="center" class="border-t pt-5 large-screen">
        <v-col v-if="!isDownloadPage" cols="12" md="8" class="pa-0">
          <v-row align="end" class="pr-2">
            <v-col cols="6" md="6" class="py-1 need_help">
              <span> {{ $t("NEED_HELP") }} {{ $t("CALL_US") }} </span>
              <span class="primary--text underline">
                <a :href="`tel:${$store.state.support_contact}`">
                  <b>{{ $store.state.support_contact }}</b>
                </a>
              </span>
            </v-col>
            <v-col cols="6" md="6" class="text-right py-2">
              <div v-if="is_card" class="d-flex justify-end elevation-0 px-3">
                <div v-if="is_card" class="align-self-center pr-5">
                  <v-btn
                    rounded
                    block
                    outlined
                    @click="
                      $router.push({
                        name: 'editCard',
                        params: { card_id: card_table_id }
                      })
                    "
                  >
                    <v-icon class="px-1">{{ mdiPencil }}</v-icon>
                    {{ $t("EDIT") }}
                  </v-btn>
                </div>
                <div
                  v-if="is_card"
                  @click="logFirebaseEvent('click_payment_get_this_card')"
                >
                  <v-btn
                    class="px-5"
                    rounded
                    block
                    color="primary"
                    dark
                    style="max-width:228px;"
                    @click="downloadDialog = true"
                  >
                    <span class="px-5">
                      {{ $t("DOWNLOAD_CARD") }}
                    </span>
                  </v-btn>
                </div>
              </div>
              <div v-if="!is_card" class="d-flex justify-end elevation-0">
                <div>
                  <v-btn
                    v-if="template_id"
                    class="px-5"
                    rounded
                    color="primary"
                    dark
                    @click="
                      $router.push({
                        name: 'createCard',
                        params: { template_id }
                      })
                    "
                  >
                    <span class="mx-2">
                      {{ $t("TRY_THIS_CARD_FOR_FREE") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" md="8" class="pa-0">
          <v-row align="end" class="pr-2 need_help">
            <v-col cols="6" md="6" class="py-1">
              <span> {{ $t("NEED_HELP") }} {{ $t("CALL_US") }} </span>
              <span class="primary--text underline">
                <a :href="`tel:${$store.state.support_contact}`">
                  <b>{{ $store.state.support_contact }}</b>
                </a>
              </span>
            </v-col>
            <v-col cols="6" md="6" class="text-right py-2">
              <div v-if="is_card" class="d-flex justify-end elevation-0 px-3">
                <div v-if="is_card">
                  <v-btn
                    class="px-5"
                    rounded
                    block
                    color="primary"
                    dark
                    style="max-width:228px;"
                    :loading="downloading"
                    @click="handleDownloadCardOnDownloadPage"
                  >
                    <span class="px-5">
                      {{ $t("DOWNLOAD_CARD") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- %%%%%%%%%%%%%%%% SHARE DIALOG  %%%%%%%%%%%%%%%%% -->

      <ShareDialogBox
        ref="sharePopup"
        v-model="share_dialog"
        :card-id="template_details.id"
        :shareable-link="sharable_link"
      >
      </ShareDialogBox>

      <!-- %%%%%%%%%%%%%%%% DOWNLOAD DIALOG  %%%%%%%%%%%%%%%%% -->

      <DownloadDialogBox
        v-model="downloadDialog"
        :template-details="template_details.template_details"
        :card-id="card_table_id"
        card_type="pdf_card"
        @payment="onPayment"
      />
    </v-container>

    <v-footer
      v-if="$route.name !== 'sharedCard'"
      bottom
      fixed
      class="d-sm-none body-bg"
    >
      <v-container>
        <v-row no-gutters justify="center">
          <v-col
            v-if="!isDownloadPage && is_card"
            @click="logFirebaseEvent('click_payment_get_this_card')"
          >
            <v-btn
              color="primary"
              dark
              rounded
              large
              block
              @click="downloadDialog = true"
            >
              {{ $t("DOWNLOAD_CARD") }}
            </v-btn>
          </v-col>
          <v-col v-if="!isDownloadPage && !is_card">
            <v-btn
              v-if="template_id"
              color="primary"
              dark
              rounded
              large
              block
              :to="{
                name: 'createCard',
                params: { template_id }
              }"
            >
              {{ $t("TRY_THIS_CARD_FOR_FREE") }}
            </v-btn>
          </v-col>
          <v-col v-if="isDownloadPage && is_card">
            <v-btn
              color="primary"
              dark
              rounded
              large
              block
              :loading="downloading"
              @click="handleDownloadCardOnDownloadPage"
            >
              {{ $t("DOWNLOAD_CARD") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <a ref="downloader" download="invitation.pdf" href="#"></a>
  </div>
</template>

<script>
import urls from "@/app-js/urls.js";
import { mdiPencil, mdiShareVariant } from "@mdi/js";
import CardPDFPreview from "@/components/cards/CardPDFPreview";

export default {
  metaInfo() {
    return {
      title: `Template Preview (${this.template_details.id})`,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: undefined
        }
      ]
    };
  },

  components: {
    CardPDFPreview,
    ShareDialogBox: () => import("@/components/dialogs/ShareDialog.vue"),
    DownloadDialogBox: () => import("@/components/dialogs/DownloadDialog.vue"),
    BaseToolbar: () => import("@/components/BaseToolbar")
  },

  data() {
    return {
      mdiPencil,
      mdiShareVariant,
      is_card: false,
      card_table_id: null,
      template_id: "",
      template_details: {},
      sharable_link: "",
      share_dialog: false,
      shareDialogLoading: false,
      html_url: "",
      downloadDialog: false,
      downloading: false,
      pdfUrl: ""
    };
  },

  prefetch() {
    this.template_details = {};
    this.card_table_id = null;
    this.template_id = null;
    this.pdfUrl = "";
    this.is_card = false;

    if (
      ["previewCard", "downloadCard", "sharedCard"].includes(this.$route.name)
    ) {
      this.is_card = true;
      return this.fetchCardDetails();
    } else if (
      ["templatesDetails", "sharedTemplate"].includes(this.$route.name)
    ) {
      if (this.$route.params.template_id || this.$route.query.id) {
        return this.fetchTemplateDetails();
      }
    }
  },

  computed: {
    isDownloadPage() {
      return this.$route.name === "downloadCard";
    }
  },

  methods: {
    async fetchPdf(url) {
      const u = new URL(url);
      const response = await this.$axios.get(u.pathname, {
        responseType: "arraybuffer"
      });
      console.log(response.data);
      this.pdfData = response.data;
    },

    async fetchTemplateDetails() {
      if (this.$route.name === "sharedTemplate") {
        const params = {
          share_id: this.$route.query.id
        };
        const response = await this.$axios.get(urls.SHARE_TEMPLATE, { params });
        this.template_details = response.data.template_details;
        this.template_id = this.template_details.id;
        this.pdfUrl = response.data.template_details.pdf_url;
      } else if (this.$route.name === "templatesDetails") {
        this.template_id = this.$route.params.template_id;
        const params = {
          template_id: this.template_id,
          lang: this.$store.state.language
        };
        const response = await this.$axios.get(urls.SUGGEST_CARD, { params });
        this.template_details = response.data.suggestions;
        this.pdfUrl = response.data.suggestions.pdf_url;
        this.logFirebaseEvent("VIEW_ITEM", {
          currency: "INR",
          value: parseFloat(this.template_details.price_android_discounted),
          items: [
            {
              item_id: this.template_details.id,
              price: parseFloat(this.template_details.price_android_discounted)
            }
          ]
        });
      }
    },

    async fetchCardDetails() {
      if (this.$route.name === "sharedCard") {
        const params = {
          share_id: this.$route.query.id
        };
        const response = await this.$axios.get(urls.SHARE_CARD, { params });
        this.template_details = response.data.card_details;
        this.card_table_id = response.data.card_details.id;
        this.pdfUrl = response.data.card_details.preview_url;
      } else {
        this.card_table_id = this.$route.params.card_id;
        const params = {
          card_table_id: this.card_table_id
        };
        const response = await this.$axios.get(urls.GET_CARD, { params });
        this.template_details = response.data.wedding_card;
        this.pdfUrl = response.data.wedding_card.preview_url;
      }
    },

    async shareCardTemplate() {
      let url;
      const form = new FormData();

      if (this.is_card) {
        form.append("card_id", this.card_table_id);
        url = urls.SHARE_CARD;
      } else {
        url = urls.SHARE_TEMPLATE;
        form.append("template_id", this.template_id);
      }

      this.shareDialogLoading = true;
      try {
        const response = await this.$axios.post(url, form);
        this.sharable_link = response.data.dynamic_link;
        if (navigator.share) {
          navigator
            .share({
              text: this.$t(
                this.is_card ? "TXT_SHARE_CARD" : "TXT_SHARE_TEMPLATE"
              ),
              url: this.sharable_link
            })
            .catch(() => {
              this.share_dialog = true;
            });
        } else {
          this.share_dialog = true;
        }
      } finally {
        this.shareDialogLoading = false;
      }
    },

    async handleDownloadCardOnDownloadPage() {
      this.downloading = true;
      try {
        const response = await this.$axios.get("/card/pdf/", {
          params: {
            card_table_id: this.card_table_id
          },
          responseType: "blob"
        });
        this.$refs.downloader.href = URL.createObjectURL(
          new Blob([response.data])
        );
        this.$refs.downloader.click();
      } finally {
        this.downloading = false;
      }
    },

    onPayment() {
      this.logFirebaseEvent("payment_success");
      this.downloadDialog = false;
      this.$router.replace({
        name: "downloadCard",
        params: {
          card_id: this.card_table_id
        }
      });
    }
  }
};
</script>
